export var OverlappingOrderWarningPageText;
(function (OverlappingOrderWarningPageText) {
    OverlappingOrderWarningPageText["DEFAULT_TITLE"] = "Overlapping Order Warning";
    OverlappingOrderWarningPageText["DEFAULT_REJECT_MESSAGE"] = "There is already an order during this week. You can either choose your {meal_entity_name_plural} on My Account or create another order.";
    OverlappingOrderWarningPageText["START_OVER"] = "Start Over";
    OverlappingOrderWarningPageText["VIEW_ORDER_HISTORY"] = "View Order History";
    OverlappingOrderWarningPageText["CHOOSE_MEALS"] = "Choose {meal_entity_name_plural}";
    OverlappingOrderWarningPageText["CREATE_ORDER"] = "Create Order";
})(OverlappingOrderWarningPageText || (OverlappingOrderWarningPageText = {}));
